import { render, staticRenderFns } from "./internship_item.vue?vue&type=template&id=d4de55f6&scoped=true"
import script from "./internship_item.vue?vue&type=script&lang=js"
export * from "./internship_item.vue?vue&type=script&lang=js"
import style0 from "./internship_item.vue?vue&type=style&index=0&id=d4de55f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4de55f6",
  null
  
)

export default component.exports